export default {
  'menu.system.model-monitor': 'Model Monitor',
  'menu.welcome': 'Welcome',
  'menu.more-blocks': 'More Blocks',
  'menu.home': 'Home',
  'menu.admin': 'Admin',
  'menu.admin.sub-page': 'Sub-Page',
  'menu.login': 'Login',
  'menu.register': 'Register',
  'menu.register-result': 'Register Result',
  'menu.dashboard': 'Dashboard',
  'menu.dashboard.analysis': 'Analysis',
  'menu.dashboard.cockpit': 'Cockpit',
  'menu.dashboard.sales': 'Sales',
  'menu.dashboard.finance': 'Finance',
  'menu.dashboard.finance-receivable': 'Finance Receivable',
  'menu.dashboard.finance-invoicing': 'Finance Invoicing',
  'menu.dashboard.finance-risk': 'Finance Risk Control',
  'menu.dashboard.finance-collection': 'Finance Collection',
  'menu.dashboard.finance-payable': 'Finance Payable',
  'menu.dashboard.monitor': 'Monitor',
  'menu.dashboard.workplace': 'Workplace',
  'menu.exception.403': '403',
  'menu.exception.404': '404',
  'menu.exception.500': '500',
  'menu.form': 'Form',
  'menu.form.basic-form': 'Basic Form',
  'menu.form.step-form': 'Step Form',
  'menu.form.step-form.info': 'Step Form(write transfer information)',
  'menu.form.step-form.confirm': 'Step Form(confirm transfer information)',
  'menu.form.step-form.result': 'Step Form(finished)',
  'menu.form.advanced-form': 'Advanced Form',
  'menu.list': 'List',
  'menu.list.table-list': 'Search Table',
  'menu.list.basic-list': 'Basic List',
  'menu.list.card-list': 'Card List',
  'menu.list.search-list': 'Search List',
  'menu.list.search-list.articles': 'Search List(articles)',
  'menu.list.search-list.projects': 'Search List(projects)',
  'menu.list.search-list.applications': 'Search List(applications)',
  'menu.profile': 'Profile',
  'menu.profile.basic': 'Basic Profile',
  'menu.profile.advanced': 'Advanced Profile',
  'menu.result': 'Result',
  'menu.result.success': 'Success',
  'menu.result.fail': 'Fail',
  'menu.exception': 'Exception',
  'menu.exception.not-permission': '403',
  'menu.exception.not-find': '404',
  'menu.exception.server-error': '500',
  'menu.exception.trigger': 'Trigger',
  'menu.account': 'Account',
  'menu.account.center': 'Account Center',
  'menu.account.settings': 'Account Settings',
  'menu.account.trigger': 'Trigger Error',
  'menu.account.logout': 'Logout',
  'menu.email': 'Public Email',
  'menu.email.inbox': 'Inbox',
  'menu.email.public-inbox': 'Public Email Inbox',
  'menu.email.hr-inbox': 'HR Inbox',
  'menu.email.compose': 'Compose',
  'menu.email.sent': 'Sent',
  'menu.email.draft': 'Draft',
  'menu.email.trash': 'Trash',
  'menu.email.settings': 'Settings',
  'menu.email.statistics': 'Statistics',
  'menu.report': 'Report Center',
  'menu.report.customer-aging': 'Customer Aging Report',
  'menu.report.supplier-aging': 'Supplier Aging Report',
  'menu.report.accounts-receivable-details-summary': 'Accounts Receivable Details',
  'menu.report.accounts-payable-details-summary': 'Accounts Payable Details',
  'menu.report.customer-management-fee-details': 'Customer Management Fee Details',
  'menu.report.supplier-settlement': 'Supplier Settlement Report',
  'menu.general': 'Human Resources',
  'menu.general.employee-archive': 'Employee Archives',
  'menu.general.employee-archive.employee-management': 'Employee Management',
  'menu.general.attendance-center': 'Attendance Center',
  'menu.general.attendance-center.punch-records': 'Punch Records',
  'menu.general.attendance-center.attendance-summary': 'Attendance Summary',
  'menu.general.attendance-device': 'Attendance Devices',
  'menu.general.attendance-device.device-info': 'Device Information',
  'menu.general.welfare-management': 'Welfare Management',
  'menu.general.welfare-management.welfare-list': 'Welfare List',
  'menu.general.hr': 'HR Management',
  'menu.general.hr.attendance-summary': 'Attendance Summary',
  'menu.general.hr.day-swap': 'Day Swap',
  'menu.general.hr.department-performance-target': 'Team Annual Performance',
  'menu.system.external-interaction-log': 'External System Interaction Logs',
  'menu.editor': 'Graphic Editor',
  'menu.editor.flow': 'Flow Editor',
  'menu.editor.mind': 'Mind Editor',
  'menu.editor.koni': 'Koni Editor',
};
